import { lazy } from "react";
import { Navigate } from "react-router-dom";
// Membership — sección autocontenida montada bajo /membership.
//
// ANATOMÍA DE LA SECCIÓN (master–detail con related lists):
//   • /membership/members            padrón — la lista de personas
//   • /membership/members/:memberId  expediente — donde se TRABAJA sobre una
//     persona: sus contactos, sus pagos y sus documentos, en pestañas. El alta
//     que sale de acá no pide el miembro, lo fija la pantalla.
//   • /membership/contacts | /payments | /payment-methods | /documents
//     vistas de colección — la misma información mirada de forma transversal,
//     para el trabajo que cruza miembros (conciliar caja, perseguir firmas,
//     buscar de quién es un teléfono, ver qué tarjetas están por vencer).
//
// Cada ítem vive en su propia carpeta con la misma anatomía (common/,
// components/, pages/, services/) y la forma la pone el kit compartido
// src/modules/shared/membership.
//
// EN DESARROLLO: oculto en producción. El módulo resuelve su propio gating —
// si MEMBERSHIP_ENABLED es false no publica rutas, así routes.js/AppRouter no
// necesitan condicionales. El sidebar gatea aparte en navigationConfig.
import { MEMBERSHIP_ENABLED, MEMBERSHIP_BASE_PATH } from "./common/constants";

// React.lazy SIEMPRE: nada del módulo viaja en el bundle inicial.
const MembersPage = lazy(() => import("./members/pages/MembersPage"));
const MemberRecordPage = lazy(() => import("./members/pages/MemberRecordPage"));
const ContactsPage = lazy(() => import("./contacts/pages/ContactsPage"));
const PaymentsPage = lazy(() => import("./payments/pages/PaymentsPage"));
const PaymentMethodsPage = lazy(() => import("./payment-methods/pages/PaymentMethodsPage"));
const DocumentsPage = lazy(() => import("./documents/pages/DocumentsPage"));

export const membershipRoutes = MEMBERSHIP_ENABLED
  ? [
      // La sección no tiene landing propia: entra por el padrón, que es la
      // pantalla de trabajo. Cuando haya un tablero de la sección, esta ruta
      // pasa a apuntarle.
      { path: MEMBERSHIP_BASE_PATH, element: <Navigate to={`${MEMBERSHIP_BASE_PATH}/members`} replace /> },
      { path: `${MEMBERSHIP_BASE_PATH}/members`, element: <MembersPage /> },
      { path: `${MEMBERSHIP_BASE_PATH}/members/:memberId`, element: <MemberRecordPage /> },
      { path: `${MEMBERSHIP_BASE_PATH}/contacts`, element: <ContactsPage /> },
      { path: `${MEMBERSHIP_BASE_PATH}/payments`, element: <PaymentsPage /> },
      { path: `${MEMBERSHIP_BASE_PATH}/payment-methods`, element: <PaymentMethodsPage /> },
      { path: `${MEMBERSHIP_BASE_PATH}/documents`, element: <DocumentsPage /> },
    ]
  : [];

export { MEMBERSHIP_ENABLED, MEMBERSHIP_BASE_PATH } from "./common/constants";
